import { createApp } from 'vue'
import Accessibility from './Accessibility.vue';
import router from "@/router/mobileMenu.router";

createApp(Accessibility).use(router).mount('#accessibility')
